// How long the browser gets to read a file's metadata, so one that never answers
// can't hold the upload back.
const METADATA_TIMEOUT_MS = 3000;

// Resolves with the file's duration in ms, or null when the browser can't tell, such
// as for a codec it can't decode or a WebM recording without a duration. The backend
// probe still checks the uploaded source.
export const readVideoDuration = (file: File): Promise<number | null> =>
  new Promise((resolve) => {
    const video = document.createElement('video');
    const url = URL.createObjectURL(file);
    const finish = (durationInMs: number | null) => {
      clearTimeout(timeout);
      URL.revokeObjectURL(url);
      resolve(durationInMs);
    };
    const timeout = setTimeout(() => finish(null), METADATA_TIMEOUT_MS);

    video.preload = 'metadata';
    video.onloadedmetadata = () => finish(Number.isFinite(video.duration) ? video.duration * 1000 : null);
    video.onerror = () => finish(null);
    video.src = url;
  });
